export default "__VITE_ASSET__DmlQmX5U__"